import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    MENU,
    MENU_LOGO,
    MENU_BUTTON,
    MENU_CONTAINER_MAIN,
    MENU_CONTAINER_LEFT,
    MENU_CONTAINER_CENTER,
    MENU_CONTAINER_RiGHT
} from '../utils/classes'
import { default as cls } from '../utils/classnames';
import './_styles.scss';
import store from 'src/store';
import { setFromData } from 'src/actions/navbar';
import { sendGAEvent } from 'src/utils/analytics';

export interface IMenuItemProps {
    id: string,
    key?: string,
    direction?: {
        left?: string,
        right?: string,
        up?: string,
        down?: string,
    }
    className?: string,
    title?: string,
    iconClassName?: string,
    nodeTo?: string,
    onClick?: () => void,
    onFocus?: () => void,
    onBlur?: () => void,
    value: React.ReactNode;
    children?: React.ReactNode;
    isActive: boolean;
    isImage: boolean;
}

export interface IMenuProps {
    className?: string,
    logo: {
        imageLogo?: string,
        className?: string,
    }
    leftItem: IMenuItemProps,
    menuItems: [IMenuItemProps],
    rightItem: IMenuItemProps
}

const metricOptionMundial = (value: any) => {
  const valueLower = value && typeof value === 'string' ? value.toLowerCase() : '';
  const isNodeMundial =valueLower ? valueLower.includes('mundial') : false;

  isNodeMundial && sendGAEvent({
    hitType: 'event',
    eventCategory: 'top menu',
    eventAction: 'click',
    eventLabel: valueLower
  })
}

const MenuItem = ({ id, key, className, nodeTo,
    direction: { up, down, left, right } = {}, title, value, children, isActive, isImage,
    onClick, onFocus, onBlur }: IMenuItemProps): React.ReactNode => {
    let directionProps: any = {};
    if (right) directionProps['data-sn-right'] = right;
    if (left) directionProps['data-sn-left'] = left;
    if (up) directionProps['data-sn-up'] = up;
    if (down) directionProps['data-sn-down'] = down;

    return (<div className={`${MENU_BUTTON}${isImage?' image-container':''}`}>
        {children?
        children:
        <NavLink
          id={`menu-${id}`}
          className={cls(
            `${className}`,
            `focusable`,
            `menu-item`,
            isActive? 'active':'inactive'
        )}
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={()=>{
            metricOptionMundial(value)
            store.dispatch(setFromData({node_initial: title}));
            onClick;
          }
        }
          to={nodeTo}
          title={title}
          {...directionProps}
        >
          {value}
        </NavLink>
        }
    </div>);
}

export const AAFMenu = ({
    className,
    menuItems,
    leftItem,
    rightItem,
    logo: { imageLogo = '', className: imgClassName = '' },
}: IMenuProps) => {
    const totalItems = menuItems.length;
    const leftValue: React.ReactNode = <i className="fa fa-search"></i>;
    const { id: idLeftItem } = leftItem;
    const [secondItem = { id: '' }, ...rest] = menuItems;
    const { id: idSecondItem } = secondItem;
    const snLeftFirstElement = `#menu-${idLeftItem}`;
    const snLeftSecondElement = `#menu-${idSecondItem}`;

    return (
        <div className={cls(
            `${className ? className : ''}`,
            MENU)}>
            <div className={cls(MENU_CONTAINER_MAIN)}>
                <div className={cls(MENU_CONTAINER_LEFT)} >
                    {MenuItem({
                        ...leftItem, value: leftValue,
                        direction: {
                            left: snLeftFirstElement,
                            right: snLeftSecondElement
                        }
                    })}
                </div>
                <div className={cls(MENU_CONTAINER_CENTER)} id={MENU_CONTAINER_CENTER}>
                    {menuItems.map((menuItem, index, arrayItems) => {
                        const { direction = {} } = menuItem;
                        menuItem.direction = direction;
                        if (index === 0) {
                            menuItem.direction.left = snLeftFirstElement;
                        } else if (index > 0) {
                            const { id } = arrayItems[index - 1];
                            menuItem.direction.left = `#menu-${id}`;
                            if (index === totalItems - 1) {
                                menuItem.direction.right = `.aaf_menu-container-right .aaf_focusable.focusable`;
                            }
                            if (index < totalItems - 1) {
                                const { id } = arrayItems[index + 1];
                                menuItem.direction.right = `#menu-${id}`;
                            }
                        }

                        return MenuItem(menuItem)
                    })}
                </div>
                <div className={cls(MENU_CONTAINER_RiGHT)}>
                    {MenuItem(rightItem)}
                </div>
            </div>
            <div className={cls(MENU_LOGO)}>
                <img className={cls(imgClassName)} src={imageLogo} alt="claroTv logo" />
            </div>

        </div>
    )
};

export default AAFMenu;



// WEBPACK FOOTER //
// ./src/packages/components/lib/AAFMenu/index.tsx